module.exports = __webpack_public_path__ + "img/home-bg.ebbddbc0.jpg";